import { useCallback, useEffect, useState } from "react";
import {
  DEFAULT_FORMS_LIST_PREFERENCES,
  type FormsListPreferences,
  loadFormsListPreferences,
  saveFormsListPreferences,
} from "../lib/admin/formsListPreferences";

export function useFormsListPreferences() {
  const [preferences, setPreferences] = useState<FormsListPreferences>(() =>
    loadFormsListPreferences(),
  );

  useEffect(() => {
    saveFormsListPreferences(preferences);
  }, [preferences]);

  const updatePreferences = useCallback(
    (patch: Partial<FormsListPreferences>) => {
      setPreferences((current) => ({ ...current, ...patch }));
    },
    [],
  );

  const resetFilters = useCallback(() => {
    setPreferences((current) => ({
      ...current,
      search: DEFAULT_FORMS_LIST_PREFERENCES.search,
      status: DEFAULT_FORMS_LIST_PREFERENCES.status,
    }));
  }, []);

  const resetAll = useCallback(() => {
    setPreferences({ ...DEFAULT_FORMS_LIST_PREFERENCES });
  }, []);

  return {
    preferences,
    updatePreferences,
    resetFilters,
    resetAll,
  };
}
